import { render, staticRenderFns } from "./EstateDutyCosts.vue?vue&type=template&id=3cab791a"
import script from "./EstateDutyCosts.vue?vue&type=script&lang=js"
export * from "./EstateDutyCosts.vue?vue&type=script&lang=js"
import style0 from "./EstateDutyCosts.vue?vue&type=style&index=0&id=3cab791a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports